import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomePageDataService {

  constructor(private http: HttpClient) { }

  // =========================
  // Home Page Data
  // =========================

  getHomePageTotals(): Observable<any> {
    return this.http.get(`${environment.Server_URL}/homepage-data/totals`);
  }
}